import { render, staticRenderFns } from "./EffectivinessForSeason.vue?vue&type=template&id=5fb83920"
import script from "./EffectivinessForSeason.vue?vue&type=script&lang=js"
export * from "./EffectivinessForSeason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports